import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import useIsSmallMobile from '../custom-hooks/useIsSmallMobile';

const CustomTextField = ({
  label,
  placeholder,
  type = 'text',
  prefix,
  suffix,
  onChange,
  value,
  isTextArea,
  rows = 4,
  sx = {},
  onKeyDown,
  disabled = false,
}: {
  label?: string;
  placeholder?: string;
  type?: string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  value?: string;
  isTextArea?: boolean;
  rows?: number;
  sx?: object;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  disabled?: boolean;
}) => {
  const smMobile = useIsSmallMobile();

  return (
    <>
      {isTextArea ? (
        <Box sx={{ position: 'relative' }}>
          {label && (
            <Typography
              component="label"
              sx={{
                px: { xs: 3, sm: 10 },
                fontSize: { xs: '14px', sm: '16px' },
              }}
            >
              {label}
            </Typography>
          )}
          <Box
            sx={{
              backgroundColor: '#a9dcf7',
              borderTopRightRadius: '20px',
              borderBottomRightRadius: '20px',
              borderRadius: { xs: 'none', sm: '30px' },
              mb: 2,
              overflow: 'hidden',
            }}
          >
            <TextField
              variant="filled"
              fullWidth
              value={value}
              placeholder={placeholder}
              multiline
              rows={rows}
              onChange={onChange}
              onKeyDown={onKeyDown}
              disabled={disabled}
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                '& .MuiFilledInput-root': {
                  borderTopRightRadius: '20px',
                  borderBottomRightRadius: '20px',
                  backgroundColor: '#a9dcf7',
                  px: { xs: smMobile ? '45px' : '70px', sm: '110px' },
                  py: 2,
                  fontSize: '14px',
                  color: '#000',
                  alignItems: 'flex-start',
                },
                '& .MuiFilledInput-input': {
                  padding: 0,
                  '::placeholder': {
                    color: '#444',
                    opacity: 1,
                  },
                },
                ...sx,
              }}
            />
          </Box>
          {suffix}
        </Box>
      ) : (
        <Box>
          <Typography
            component="label"
            sx={{
              px: { xs: 3, sm: 10 },
              fontSize: { xs: '14px', sm: '16px' },
            }}
          >
            {label}
          </Typography>

          <Box
            sx={{
              backgroundColor: '#a9dcf7',
              borderTopRightRadius: '35px',
              borderBottomRightRadius: '35px',
              borderRadius: { xs: 'none', sm: '30px' },
              mb: 2,
              overflow: 'hidden',
              width: '100%',
              '&:hover': {
                backgroundColor: '#a9dcf7',
              },
            }}
          >
            <TextField
              fullWidth
              type={type}
              value={value}
              variant="filled"
              placeholder={placeholder}
              disabled={disabled}
              InputProps={{
                disableUnderline: true,
                startAdornment: prefix && (
                  <InputAdornment position="start">{prefix}</InputAdornment>
                ),
              }}
              onChange={onChange}
              sx={{
                '& .MuiFilledInput-root': {
                  borderTopRightRadius: '35px',
                  borderBottomRightRadius: '35px',
                  backgroundColor: '#a9dcf7',
                  px: { xs: smMobile ? '25px' : '32px', sm: prefix ? '100px' : '85px' },
                  py: '6px',
                  height: '40px',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  color: '#000',
                },
                '& .MuiFilledInput-input': {
                  padding: 0,
                  '::placeholder': {
                    color: '#444',
                    opacity: 1,
                  },
                },
              }}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default CustomTextField;
